module.exports = __webpack_public_path__ + "img/menu-icon-plus.7887c63e.svg";